import _ from 'lodash'

export const FETCHING_WIDGETS = 'FETCHING_WIDGETS'
export const FETCHED_WIDGETS = 'FETCHED_WIDGETS'
export const FETCHING_WIDGET = 'FETCHING_WIDGET'
export const FETCHED_WIDGET = 'FETCHED_WIDGET'
export const NO_LOGGED_WIDGETS = 'NO_LOGGED_WIDGETS'
export const FETCHED_WIDGETS_META = 'FETCHED_WIDGETS_META'
export const LIKE_WIDGET = 'LIKE_WIDGET'
export const UNLIKE_WIDGET = 'UNLIKE_WIDGET'
export const TOGGLE_MODAL_PRIVACY = 'TOGGLE_MODAL_PRIVACY'
export const CHANGE_PRIVACY = 'CHANGE_PRIVACY'
export const ACCEPT_PRIVACY = 'ACCEPT_PRIVACY'
export const CANCEL_PRIVACY = 'CANCEL_PRIVACY'
export const SAVING_WIDGET_PRIVACY = 'SAVING_WIDGET_PRIVACY'
export const SAVE_WIDGET_PRIVACY = 'SAVE_WIDGET_PRIVACY'
export const HIDE_WIDGET_FROM_EPORTFOLIO = 'HIDE_WIDGET_FROM_EPORTFOLIO'
export const SHOW_WIDGET_FROM_EPORTFOLIO = 'SHOW_WIDGET_FROM_EPORTFOLIO'

export const SEND_GLOBAL_EVALUATION_ACTION = 'SEND_GLOBAL_EVALUATION_ACTION'
export const EVALUATE_GLOBAL_EVALUATION_ACTION = 'EVALUATE_GLOBAL_EVALUATION_ACTION'

export const PUBLICATION_SCOPE_PRIVATE = 0
export const PUBLICATION_SCOPE_TREENODE = 0.5
export const PUBLICATION_SCOPE_INTRANET = 1
export const PUBLICATION_SCOPE_PUBLIC = 2
export const PUBLICATION_SCOPE_LABELS = {
  [PUBLICATION_SCOPE_PRIVATE]: 'Private',
  [PUBLICATION_SCOPE_TREENODE]: 'Classgroup',
  [PUBLICATION_SCOPE_INTRANET]: 'Intranet',
  [PUBLICATION_SCOPE_PUBLIC]: 'Public',
}
export const PUBLICATION_SCOPE_OPTIONS = [
  {
    key: PUBLICATION_SCOPE_PRIVATE,
    label: 'Private',
    i18n: 'PUBLICATION_SCOPE_PRIVATE',
    icon: 'lock',
  },
  {
    key: PUBLICATION_SCOPE_TREENODE,
    label: 'Classgroup',
    i18n: 'PUBLICATION_SCOPE_CLASSGROUP',
    icon: 'student',
  },
  {
    key: PUBLICATION_SCOPE_INTRANET,
    label: 'Intranet',
    i18n: 'PUBLICATION_SCOPE_INTRANET',
    icon: 'university',
  },
  {
    key: PUBLICATION_SCOPE_PUBLIC,
    label: 'Public',
    i18n: 'PUBLICATION_SCOPE_PUBLIC',
    icon: 'world',
  }
]
export const WIDGET_TYPES = {
  'story': 'Story',
  'audio': 'Audio',
  'video': 'Video',
  'attachment': 'Attachment',
  'image': 'Image',
  'youtube': 'Youtube',
  'vimeo': 'Vimeo',
  'link': 'Link',
  'sequence': 'Sequence',
  'text': 'Text',
  'embed': 'Embed',
  'project': 'Portabily',
  'sketchfab': 'Sketchfab',
  'khan-academy': 'Khan Academy',
  'nasa': 'Nasa',
}

const widgetsInit = {
  isFetching: false,
  data: [],
}

export function widgets(widgets=widgetsInit, action) {
  switch(action.type) {
    case SHOW_WIDGET_FROM_EPORTFOLIO:
      return {
        ...widgets,
        data: [
          ...widgets.data,
          action.widget,
        ]
      }

    case HIDE_WIDGET_FROM_EPORTFOLIO:
      return {
        ...widgets,
        data: _.chain(widgets.data).map(widget => {
          if (widget.id === action.widgetId) {
            return null
          }
          return widget
        }).compact().value()
      }

    case FETCHING_WIDGETS:
      if(action.infinityScroll) {
        return {
          ...widgets,
          isFetching: true,
        }
      }

      return {
        isFetching: true,
        data: [],
      }

    case FETCHED_WIDGETS:
      if(action.infinityScroll) {
        return {
          isFetching: false,
          data: [
            ...widgets.data,
            ...action.widgets,
          ],
        }
      }

      return {
        isFetching: false,
        data: action.widgets,
      }

    case SAVE_WIDGET_PRIVACY:
      return {
        ...widgets,
        data: _.map(
          widgets.data,
          widget => {
            if (widget.id === action.widgetId) {
              let treenodes = widget.treenodes

              if (action.publicationScope === PUBLICATION_SCOPE_TREENODE)
                treenodes = _.map(action.treeNodes, treenode => ({
                  id: treenode,
                }))

              return {
                ...widget,
                publicationScope: action.publicationScope,
                treenodes,
              }
            }

            return widget
          }
        )
      }

    case LIKE_WIDGET:
      return {
        ...widgets,
        data: _.map(widgets.data, widget => {
          if (widget.id === action.widgetId) {
            return {
              ...widget,
              analytics: {
                ...widget.analytics,
                likes: widget.analytics.likes + 1,
                likesByMe: true,
              },
            }
          }
          return widget
        })
      }

    case UNLIKE_WIDGET:
      return {
        ...widgets,
        data: _.map(widgets.data, widget => {
          if (widget.id === action.widgetId) {
            return {
              ...widget,
              analytics: {
                ...widget.analytics,
                likes: widget.analytics.likes - 1,
                likesByMe: false,
              },
            }
          }
          return widget
        })
      }

    case SEND_GLOBAL_EVALUATION_ACTION:
    case EVALUATE_GLOBAL_EVALUATION_ACTION:
      const data = _.chain(widgets.data).map(
        widget => {
          if (widget.id === action.widget.id) {
            const owner = widget.owner
            return {
              ...widget,
              ...action.widget,
              owner,
              touched: 1,
            }
          }
          return widget
        }
      ).sortBy('touched').value()

      return {
        ...widgets,
        data,
      }

    default:
      return widgets
  }
}

const widgetInit = {
  isFetching: false,
  data: {},
}

export function widget(widget=widgetInit, action) {
  switch(action.type) {
    case FETCHING_WIDGET:
      return {
        isFetching: true,
        data: {},
      }

    case FETCHED_WIDGET:
      return {
        isFetching: false,
        data: action.widget,
      }

    case SAVE_WIDGET_PRIVACY:
      if (widget.data.id === action.widgetId) {
        let treenodes = widget.data.treenodes

        if (action.publicationScope === PUBLICATION_SCOPE_TREENODE)
          treenodes = _.map(action.treeNodes, treenode => ({
            id: treenode,
          }))

        return {
          ...widget,
          data: {
            ...widget.data,
            publicationScope: action.publicationScope,
            treenodes,
          }
        }
      }
      return widget

    case LIKE_WIDGET:
      if (widget.id !== action.widgetId) return widget
      return {
        ...widget,
        data: {
          ...widget.data,
          analytics: {
            ...widget.data.analytics,
            likes: widget.data.analytics.likes + 1,
            likesByMe: true,
          },
        }
      }

    case UNLIKE_WIDGET:
      if (widget.id !== action.widgetId) return widget
      return {
        ...widget,
        data: {
          analytics: {
            ...widget.data.analytics,
            likes: widget.data.analytics.likes - 1,
            likesByMe: false,
          },
        }
      }

    default:
      return widget
  }
}

const metaInitial = {
  count: 0,
  countWithoutPrivacy: 0,
  maxPage: 0,
  currentPage: 1,
}

export function widgetsMeta(meta=metaInitial, action) {
  switch(action.type) {
    case FETCHED_WIDGETS_META:
      return action.meta
    default:
      return meta
  }
}


const privacyInitial = {
  widgetId: null,
  publicationScope: null,
  treeNodes: [],
  open: false,
  isSaving: true,
}

export function widgetPrivacy(privacy=privacyInitial, action) {
  switch(action.type) {
    case TOGGLE_MODAL_PRIVACY:
      return {
        isSaving: false,
        widgetId: action.widgetId,
        publicationScope: action.publicationScope,
        treeNodes: action.treeNodes,
        open: action.open,
      }
    case CHANGE_PRIVACY:
      return {
        ...privacy,
        publicationScope: action.publicationScope,
        treeNodes: action.treeNodes,
      }
    case SAVING_WIDGET_PRIVACY:
      return {
        ...privacy,
        isSaving: true,
      }
    case SAVE_WIDGET_PRIVACY:
      return {
        ...privacy,
        isSaving: false,
      }
    default:
      return privacy
  }
}
